export enum EAdminAccountQueryKey {
  ADMIN_ACCOUNT = 'ADMIN_ACCOUNT',
  ADMIN_ACCOUNTS = 'ADMIN_ACCOUNTS',
  ADMIN_ACCOUNT_BY_EMAIL = 'ADMIN_ACCOUNT_BY_EMAIL',
  ADMIN_ACCOUNT_BY_PHONE = 'ADMIN_ACCOUNT_BY_PHONE',
  ADMIN_USER = 'ADMIN_USER',
  ADMIN_USER_BY_EMAIL = 'ADMIN_USER_BY_EMAIL',
  ADMIN_USER_BY_PHONE = 'ADMIN_USER_BY_PHONE',
  ADMIN_USER_BY_ID = 'ADMIN_USER_BY_ID',
  ADMIN_MISSIONS = 'ADMIN_MISSIONS',
  ADMIN_USER_PORTFOLIO = 'ADMIN_USER_PORTFOLIO',
  ADMIN_USER_OTC_HISTORY = 'ADMIN_USER_OTC_HISTORY',
  ADMIN_USER_BANK_ACCOUNTS = 'ADMIN_USER_BANK_ACCOUNTS',
}
